import React from 'react';
import { SplitFlapChar } from './SplitFlapChar';
type Props = {
  text: string;
  length?: number;
  size?: 'sm' | 'lg';
  tone?: 'dark' | 'light';
  label?: string;
};

/** A row of split-flap tiles, padded to a fixed length so columns stay aligned. */
export function FlapText({
  text,
  length,
  size = 'sm',
  tone = 'dark',
  label
}: Props) {
  const value = (length ? text.padEnd(length, ' ').slice(0, length) : text).toUpperCase();
  return <span className="inline-flex gap-[3px]" role="text" aria-label={label ?? text} data-id="element-139" data-mp="5956ivi4n2uf">
      {value.split('').map((c, i) => <SplitFlapChar key={i} char={c} size={size} tone={tone} data-id="element-140" data-mp="cwieslybzb4" data-mpi={i} />)}
    </span>;
}